<template>
  <scoped>
    <div>
      <Button
        title="&#8678;"
        :disabled="currentPage <= 1"
        @click="previousPage()"
      />
      Page
      <NumberInput
        v-model:value="currentPage"
        class="number"
        :max="pageTotal"
        :min="1"
        @change="emits('update')"
      />
      of {{ pageTotal }}
      <Button
        title="&#8680;"
        :disabled="currentPage >= pageTotal"
        @click="nextPage()"
      />
    </div>
  </scoped>
</template>

<script setup lang="ts">
  import {onMounted, ref} from "vue"
  import Button from "@/components/button.vue"
  import NumberInput from "@/components/inputs/number.vue"

  const props = defineProps({
    itemTotal: {
      default: null,
      required: true,
      type: Number,
    }
  })

  const emits = defineEmits(["update"])

  const currentPage = defineModel("currentPage", {
    default: null,
    required: true,
    type: Number,
  })
  const pageItems = defineModel("pageItems", {
    default: null,
    required: true,
    type: Number,
  })
  const pageTotal = ref<number>(null)

  onMounted(() => {
    updatePaginator()
  })

  function updatePaginator() {
    if (props.itemTotal < 1 || pageItems.value < 1) {
      pageTotal.value = 0
    } else {
      pageTotal.value = Math.ceil(props.itemTotal / pageItems.value)
    }
    currentPage.value = 1
  }

  function nextPage() {
    if (currentPage.value >= pageTotal.value) {
      currentPage.value = pageTotal.value
    } else {
      currentPage.value ++
    }
    emits("update")
  }
  
  function previousPage() {
    if (currentPage.value <= 1) {
      currentPage.value = 1
    } else {
      currentPage.value --
    }
    emits("update")
  }
</script>

<style scoped>
  .number {
    display: inline-block;
    margin: 0 0.5em;
  }
</style>
